import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Home_page/Navbar";
import Footer from "./Home_page/Footer";
import Home_Page from "./Home_page/Home";
import Services from "./Home_page/Services";
import Contact from "./Home_page/Contact";
import About_Page from "./About_page/About";
import OurTeam from "./About_page/OurTeam";
import OurServices from "./services_page/OurServices";
import Insights from "./Insights/Insights";
import FAQs from "./FAQs/FAQs";

function App() {
  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Home_Page />
              <Services />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* About Page */}
        <Route
          path="/about"
          element={
            <>
              <Navbar />
              <About_Page />
              <OurTeam />
              <Footer />
            </>
          }
        />

        {/* Services Page */}
        <Route
          path="/our-services"
          element={
            <>
              <Navbar />
              <OurServices />
              <Footer />
            </>
          }
        />

        {/* Insights Page */}
        <Route
          path="/insights"
          element={
            <>
              <Navbar />
              <Insights />
              <Footer />
            </>
          }
        />

        {/* FAQs Page */}
        <Route
          path="/faqs"
          element={
            <>
              <Navbar />
              <FAQs />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;